<template>
    <b-col cols="12"
           lg="9"
           id="section_main"
           class="section-main">

        <h3>Withdraw request</h3>
        <div v-if="isFetched">
            <div v-if="requestWasSent">
                <p></p>
                <p>
                    Your withdraw request already sent. Check 'Requests history' for withdraw status. <br>
                    You can send new request after verification of current request will be finished.
                </p>
            </div>

            <br>

            <div>
                <div>
                    <p>Available Mined FuturoCoins: {{ minedBalance }} FTO</p>
                    <p>Available Bonus FuturoCoins: {{ bonusBalance }} FTO</p>
                </div>
            </div>

            <br>

            <p> CoinDeal is about to close the FTO/BTC market on 30.06.2020.</p>

            Please use any other FTO wallet of any exchange platform.<br>
            In order to change the wallet number for your previous withdrawal request.<br>
            Please, contact our support team by e-mail
            <a href = "mailto: futuronetwork.help@gmail.com ">futuronetwork.help@gmail.com </a>.
            <br>

            <div v-if="showForm">
                <p></p>
                <p>
                    In order to make withdrawal request please fill in next data:</p>
                <ul>
                    <li>1. Your e-mail address</li>
                    <li>2. Your external FTO wallet (please make sure that you are filling in valid wallet)</li>
                    <li>3. Amount of FTO you want to withdraw</li>
                    <li>4. Click the button “Send”</li>
                </ul>

                <p>The withdrawal request will be automatically received and processed by the financial department.</p>
                <br>

                <p>Please fill-up the form:</p>

                <form @submit.prevent="validate">
                    <b-row>
                        <b-col cols
                               lg="12">
                            <div class="form-item form-item-text"
                                 :class="{ 'field-error': errors.has('email') && showErrors }">
                                <label for="withdraw_request_email"
                                       class="form-label">
                                    Email
                                </label>
                                <input id="withdraw_request_email"
                                       name="email"
                                       class="hf-bg-col"
                                       v-model="email"
                                       v-validate
                                       data-vv-rules="required"
                                       data-vv-as="withdraw email"
                                       :disabled="progress"
                                       type="text">
                                <p class="field-error--description" v-show="errors.has('email') && showErrors">{{
                                    errors.first('email') }}</p>
                            </div>

                            <div class="form-item form-item-text"
                                 :class="{ 'field-error': errors.has('address') && showErrors }">
                                <label for="withdraw_request_address"
                                       class="form-label">
                                    FTO Address
                                </label>
                                <input id="withdraw_request_address"
                                       name="address"
                                       class="hf-bg-col"
                                       v-model="address"
                                       v-validate
                                       data-vv-rules="required"
                                       data-vv-as="withdraw address"
                                       :disabled="progress"
                                       type="text">
                                <p class="field-error--description" v-show="errors.has('address') && showErrors">{{
                                    errors.first('address') }}</p>
                            </div>

                            <div class="form-item form-item-text"
                                 :class="{ 'field-error': errors.has('balance') && showErrors }">
                                <label for="withdraw_request_balance"
                                       class="form-label">
                                    FTO Balance
                                </label>
                                <select id="withdraw_request_balance"
                                        name="balance"
                                        class="select-s hf-bg-col"
                                        v-model="balance"
                                        v-validate
                                        data-vv-rules="required"
                                        data-vv-as="withdraw balance"
                                        @change="onBalanceChange($event)"
                                        :disabled="progress">
                                    <option value="MINED">Mined FTO</option>
                                    <option value="BONUS">Bonus FTO</option>
                                </select>
                                <p class="field-error--description" v-show="errors.has('balance') && showErrors">{{
                                    errors.first('balance') }}</p>
                            </div>

                            <div class="form-item form-item-text"
                                 :class="{ 'field-error': errors.has('amount') && showErrors }">
                                <label for="withdraw_request_amount"
                                       class="form-label">
                                    FTO Amount (receive: {{ amount > 0 ?(amount - ftoFee).toFixed(8) : 0}} FTO,
                                    blockchain commission: {{ftoFee}} FTO)
                                </label>
                                <input id="withdraw_request_amount"
                                       name="amount"
                                       class="hf-bg-col"
                                       v-model="amount"
                                       v-validate
                                       data-vv-rules="required"
                                       data-vv-as="withdraw amount"
                                       :disabled="progress"
                                       @input="checkAmount"
                                       type="text">
                                <p class="field-error--description" v-show="errors.has('amount') && showErrors">{{
                                    errors.first('amount') }}</p>
                            </div>

                            <div class="form-item form-item-text">
                                <label for="withdraw_request_text" class="form-label">
                                    Text note
                                </label>
                                <textarea id="withdraw_request_text" v-model="text"></textarea>
                            </div>
                        </b-col>
                        <b-col cols="12"
                               lg="5">
                        </b-col>
                        <b-col cols="12"
                               lg="7">
                            <button class="button--primary"
                                    :class="{ 'button--progress': progress }"
                                    :type="progress ? 'button' : 'submit'">Send
                            </button>
                        </b-col>
                    </b-row>
                </form>
            </div>

            <br>

            <div class="table-responsive" v-if="showHistory">
                <h4>Requests history</h4>
                <div class="table-outer">
                    <table class="table-style1">
                        <thead>
                        <tr class="business-qualifications-header-table">
                            <th style="width: 10%; text-align: center;"><p>Date</p></th>
                            <th style="width: 20%; text-align: center;"><p>Email</p></th>
                            <th style="width: 25%; text-align: center;"><p>FTO Address</p></th>
                            <th style="width: 3%; text-align: center;"><p>Balance</p></th>
                            <th style="width: 20%; text-align: right;"><p>FTO amount</p></th>
                            <th style="width: 12%; text-align: center;"><p>Status</p></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="w in requestHistory"
                            :key="w.id"
                            class="row-items"
                        >
                            <td><p>{{ w.created_at }}</p></td>
                            <td style="text-align: left;" class="cut-email"><p>{{ w.email }}</p></td>
                            <td style="text-align: left;" class="cut-address"><p>{{ w.address }}</p></td>
                            <td style="text-align: right;"><p>{{ w.balance_name }}</p></td>
                            <td style="text-align: right;"><p>{{ (w.amount / 100000000).toFixed(8) }} FTO</p></td>
                            <td style="text-align: right;"
                                :style="w.status === 'CANCELED' ? 'cursor: pointer;' : 'cursor: auto;'"
                                @click="clickItem(w)">
                                <p>
                                    <i v-if="w.status === 'CANCELED'" class="mdi mdi-18px mdi-information-outline"
                                       style="color: red;"></i>
                                    {{ w.status === 'IN_PROGRESS' ? 'IN PROGRESS' : w.status }}
                                </p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </b-col>
</template>

<script>

    export default {
        dependencies: ['api', 'status', 'ftoAccounts', 'money', 'popup'],
        data() {
            return {
                progress: false,
                showErrors: false,

                email: '',
                address: '',
                text: '',
                balance: '', // BONUS, BALANCE
                amount: '',

                showForm: true,
                isFetched: true,
                requestWasSent: false,
                showHistory: false,

                ftoFee: 0.0006,
                minedBalance: 0,
                bonusBalance: 0,

                requestHistory: [
                    {
                        id: '',
                        email: '',
                        address: '',
                        amount: '',
                        status: '',
                        created_at: '',
                        reject_reason: ''
                    }
                ]
            }
        },
        methods: {
            clearData() {
                this.email = '';
                this.address = '';
                this.text = '';
                this.amount = '';
                this.balance = '';
            },
            validate() {
                this.showErrors = false;

                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        this.submit();
                    } else {
                        this.showErrors = true;
                    }
                })
            },
            onBalanceChange(event) {
                this.amount = '';
            },
            checkAmount() {
                if (this.balance.length === 0) {
                    this.popup.show('Please choose FTO balance to withdraw');
                    this.amount = '';
                    return;
                }

                this.amount = this.amount.replace(/,/g, '.');
                if (isNaN(this.amount)) {
                    this.popup.show('Not a number');
                    this.amount = '';
                    return;
                }

                if (this.amount.indexOf('.') > 0) {
                    let dig1 = this.amount.split('.')[0];
                    let dig2 = this.amount.split('.')[1];
                    if (dig2.length > 8) {
                        dig2 = dig2.substr(0, 8);
                        this.amount = dig1 + '.' + dig2;
                    }
                }

                let a = parseFloat(this.amount);
                if (this.balance === 'BONUS') {
                    if (a > parseFloat(this.bonusBalance)) {
                        this.amount = this.bonusBalance;
                    }
                }

                if (this.balance === 'MINED') {
                    if (a > parseFloat(this.minedBalance)) {
                        this.amount = this.minedBalance;
                    }
                }
            },
            clickItem(w) {
                let reject_reason = w.reject_reason;
                if (reject_reason === null) {
                    reject_reason = 'No reject reason present';
                }
                this.popup.show('Reject reason: ' + reject_reason);
            },
            checkActiveRequest() {
                this.isFetched = false;

                this.$http.get(this.api.withdraw.getLast).then(response => {
                    let reqData = response.data.data;

                    this.minedBalance = (reqData.minedBalance / 100000000).toFixed(8);
                    this.bonusBalance = (reqData.bonusBalance / 100000000).toFixed(8);

                    if (reqData.active === null) {
                        this.isFetched = true;
                        return;
                    }

                    if ((reqData.active.status === 'OPEN' || reqData.active.status === 'IN_PROGRESS')) {
                        this.requestWasSent = true;
                        this.showForm = false;
                    }

                    this.isFetched = true;
                }, error => {
                    this.popup.show('Error happened');
                });
            },

            getAllRequests() {
                this.isFetched = false;

                this.$http.get(this.api.withdraw.getAll).then(response => {
                    if (response.data.data.length === 0) {
                        this.showHistory = false;
                        return;
                    }

                    this.requestHistory = response.data.data;
                    this.showHistory = true;

                }, error => {
                    this.popup.show('Could not load history table');
                });
            },

            submit() {
                this.progress = true;

                this.amount = this.amount.replace(/,/g, '.');

                if (this.amount <= this.ftoFee) {
                    this.popup.show("Minimum withdraw amount: " + this.ftoFee + "1 FTO", 'OK', false);
                    this.progress = false;
                    return;
                }

                if (this.balance === 'MINED' && this.amount > parseFloat(this.minedBalance)) {
                    this.popup.show("Typed " + this.amount + " FTO is biggest than available " + this.balance + " amount " + this.minedBalance + " FTO", 'OK', false);
                    this.progress = false;
                    return;
                }

                if (this.balance === 'BONUS' && this.amount > parseFloat(this.bonusBalance)) {
                    this.popup.show("Typed " + this.amount + " FTO is biggest than available " + this.balance + " amount " + this.bonusBalance + " FTO", 'OK', false);
                    this.progress = false;
                    return;
                }

                this.$http.post(this.api.withdraw.send,
                    {
                        email: this.email,
                        address: this.address,
                        amount: this.amount,
                        balance: this.balance,
                        text: this.text
                    }
                ).then(() => {
                    console.log('Then');

                    this.popup.show('Withdraw request sent!', 'OK', false);
                    this.clearData();
                    this.progress = false;
                    location.reload();
                }, error => {
                    switch (error.status) {
                        case 422:
                            this.popup.show(error.data.errors[0].message, 'OK', false);
                            break;
                        default:
                            if (this.status['status' + error.status]) {
                                this.status['status' + error.status]();
                            } else {
                                this.popup.show(error.data.errors[0].message, 'OK', false);
                            }
                    }
                    this.progress = false;
                })
            }
        },
        beforeMount() {
            this.clearData();
            this.checkActiveRequest();
            this.getAllRequests();
        }
    }
</script>

<style lang="scss" scoped>

    .cut-email > p {
        white-space: nowrap;
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .cut-address > p:hover {
        white-space: unset;
        text-overflow: unset;
        font-size: 10px;
    }

    .cut-address > p {
        white-space: nowrap;
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .cut-address > p:hover {
        white-space: unset;
        text-overflow: unset;
        font-size: 10px;
    }

    .select-s {
        display: block;
        height: 40px;
        width: 100%;
        border: 2px solid #d9d9d9;
        background-color: #f7f7f7;
        line-height: 28px;
        padding: 0 6px;
        font-size: 13px;
        font-weight: 700;
    }

    .select-s > option {
        height: 40px;
        font-size: 13px;
        font-weight: 700;
    }

    .space {
        margin-bottom: 30px;
    }

    #withdraw_request_text {
        display: block;
        width: 100%;
        border: 2px solid #d9d9d9;
        background-color: #f7f7f7;
        line-height: 28px;
        padding: 0 6px;
        font-size: 13px;
        font-weight: 700;
    }

    .hf-bg-col {
        background-color: #f7f7f7 !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/withdraw/WithdrawForm.vue